import React, { Component } from "react";
import { Link } from "react-router-dom";
// import {css} from 'glamor'
import PropTypes from "prop-types";
import classNames from "classnames";

// UI
import Header from "../header";
import P from "../paragraph";
import Button from "../button";
import Row from "../row";
import Col from "../col";
import IconBack from "../icons/arrowLeft";

class HeaderPage extends Component {
  render() {
    let backButton = null;

    if (this.props.back) {
      if (typeof this.props.back === "function") {
        backButton = (
          <Button onClick={this.props.back} className="back-header">
            <IconBack />
          </Button>
        );
      } else {
        backButton = (
          <Button
            type="as"
            as={Link}
            to={this.props.back}
            className="back-header"
          >
            <IconBack />
          </Button>
        );
      }
    }

    let preTitleParagrath = null;
    if (this.props.preTitle) {
      preTitleParagrath = (
        <P slim={true} className="title__pre">
          {this.props.preTitle}
        </P>
      );
    }
    let postTitleParagrath = null;
    if (this.props.postTitle) {
      postTitleParagrath = (
        <P slim={true} className="title__post">
          {this.props.postTitle}
        </P>
      );
    }

    let preBeforeTitleParagrath = null;
    if (this.props.preBeforeTitle) {
      if (this.props.preBeforeTitleStyle) {
        preBeforeTitleParagrath = (
          <span
            className={`label size-small label-${this.props.preBeforeTitleStyle}`}
          >
            <P slim={true} className="title--before__pre">
              {this.props.preBeforeTitle}
            </P>
          </span>
        );
      } else {
        preBeforeTitleParagrath = <P slim>{this.props.preBeforeTitle}</P>;
      }
    }

    let beforeTitle = null;
    if (this.props.beforeTitle) {
      beforeTitle = (
        <Header size={6} margin="no" className="title--before">
          {this.props.beforeTitle}
        </Header>
      );
    }

    let postBeforeTitleParagrath = null;
    if (this.props.postBeforeTitle) {
      postBeforeTitleParagrath = (
        <P slim={true} className="title--before__post">
          {this.props.postBeforeTitle}
        </P>
      );
    }

    let preSubTitleParagrath = null;
    if (this.props.preSubTitle) {
      preSubTitleParagrath = (
        <P slim={true} className="sub-title__pre">
          {this.props.preSubTitle}
        </P>
      );
    }

    let subTitle = null;
    if (this.props.subTitle) {
      subTitle = (
        <Header size={6} margin="no" className="sub-title">
          {this.props.subTitle}
        </Header>
      );
    }

    let postSubTitleParagrath = null;
    if (this.props.postSubTitle) {
      postSubTitleParagrath = (
        <P slim={true} className="sub-title__post">
          {this.props.postSubTitle}
        </P>
      );
    }

    let countParagrath = null;
    if (this.props.count >= 0) {
      countParagrath = (
        <P slim={true} className="title__count">
          Всего: {this.props.count}
        </P>
      );
    }

    const titleClasses = classNames("title", this.props.titleClass);

    return (
      <div className="header-page">
        <Row align="center" className="row--main" withMain={true}>
          <Col
            // xs={{ only: 12 }}
            // sm={{ only: 12 }}
            // md={{ only: 6 }}
            // lg={{ only: 6 }}
            // xl={{ only: 6 }}
            className="container--titles"
            main={true}
          >
            <Row align="center" withMain className="row--titles">
              <Col padding="no" normal className="col--back">
                {backButton}
              </Col>

              <Col padding="no" main className="col--titles">
                <Row className="titles">
                  <Col
                    padding="no"
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className="title__before"
                  >
                    {preBeforeTitleParagrath}
                    {beforeTitle}
                    {postBeforeTitleParagrath}
                  </Col>

                  <Col
                    padding="no"
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className="title__main"
                  >
                    {preTitleParagrath}
                    <Header size={3} margin="no" className={titleClasses}>
                      {this.props.title}
                    </Header>
                    {postTitleParagrath}
                    {countParagrath}
                  </Col>

                  <Col
                    padding="no"
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className="title__after"
                  >
                    {preSubTitleParagrath}
                    {subTitle}
                    {postSubTitleParagrath}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col
            // xs={{ only: 12 }}
            // sm={{ only: 12 }}
            // md={{ only: 6 }}
            // lg={{ only: 6 }}
            // xl={{ only: 6 }}
            normal={true}
            text="right"
            className={
              "container--buttons" + (!this.props.children ? " hidden-sm" : "")
            }
          >
            {this.props.children}
          </Col>
        </Row>
      </div>
    );
  }
}

HeaderPage.defaultProps = {
  back: null,
  preBeforeTitle: null,
  preBeforeTitleStyle: null,
  beforeTitle: null,
  postBeforeTitle: null,
  preTitle: null,
  title: null,
  titleClass: null,
  postTitle: null,
  preSubTitle: null,
  subTitle: null,
  postSubTitle: null,
  children: null
};

HeaderPage.propTypes = {
  back: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  preBeforeTitle: PropTypes.string,
  preBeforeTitleStyle: PropTypes.string,
  beforeTitle: PropTypes.string,
  postBefore: PropTypes.string,
  preTitle: PropTypes.string,
  title: PropTypes.string,
  titleClass: PropTypes.string,
  postTitle: PropTypes.string,
  preSubTitle: PropTypes.string,
  subTitle: PropTypes.string,
  postSubTitle: PropTypes.string,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node
};

export default HeaderPage;
